import type { VariationComponent } from "~types/types";
import { filterForStoriesWithAudioImage } from "~utils/filterForStoriesWithAudioImage";
import {
    checkItemArrayIntegrity,
    checkMediaIntegrity,
    type IntegrityStatus,
} from "~utils/moduleIntegrity";

import { MEDIA_PRIORITY } from "./LineupContentAudio6Up";

export default function integrityCheck({
    alternateFirstItems,
}: VariationComponent): IntegrityStatus {
    if (!alternateFirstItems?.length) {
        return ["The LineupContentAudio6Up module has no items"];
    }

    const storiesWithAudio =
        filterForStoriesWithAudioImage(alternateFirstItems);
    const errorMessages = checkItemArrayIntegrity(storiesWithAudio, [
        "headline",
    ]);

    errorMessages.push(
        ...checkMediaIntegrity(storiesWithAudio, MEDIA_PRIORITY)
    );

    return errorMessages;
}
